import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=0e31ebdf&"
import script from "./SubmitButton.vue?vue&type=script&lang=ts&"
export * from "./SubmitButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports